export default __webpack_public_path__ + "static/double_door_w.bc04a7af87217ebac5cf909b6d7b3ea3.svg";